import { RowSelectionState } from '@tanstack/react-table';
import { differenceBy, unionBy } from 'lodash';
import { useEffect, useRef, useState } from 'react';

import { ReferenceSelectorItem } from '../reference-selector.model';

const getSelectionKey = (item: ReferenceSelectorItem) => {
  if (item.name && item.version) {
    return `${item.name}-${item.version}`;
  }

  return item.name || item.uuid || item.key;
};

/**
 * Is used to manage row selection in grid view
 * @param availableItems Visible items to be selected
 */
export default function useRowSelection(
  availableItems: ReferenceSelectorItem[]
) {
  const [rowSelection, setRowSelection] = useState<RowSelectionState>({});
  const selectedRows = useRef<ReferenceSelectorItem[]>([]);

  useEffect(
    function HandleSelection() {
      selectedRows.current = unionBy(
        selectedRows.current,
        availableItems.filter((item) => {
          const key = getSelectionKey(item);
          return key ? rowSelection[String(key)] : false;
        }),
        (item) => getSelectionKey(item)
      );
    },
    [rowSelection, availableItems]
  );

  useEffect(
    function HandleDeselection() {
      selectedRows.current = differenceBy(
        selectedRows.current,
        availableItems.filter((item) => {
          const key = getSelectionKey(item);
          return key ? !rowSelection[String(key)] : false;
        }),
        (item) => getSelectionKey(item)
      );
    },
    [rowSelection, availableItems]
  );

  return {
    rowSelection,
    setRowSelection,
    selectedRows,
  };
}
